// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-ec567b48].el-table .cell {\n  padding-left: 20px !important;\n}\n.mt5[data-v-ec567b48] {\n  margin-top: 5px;\n}\n[data-v-ec567b48] .el-card__body {\n  padding: 30px 24px !important;\n}\n[data-v-ec567b48] .el-form-item {\n  margin-bottom: 0px !important;\n}\n[data-v-ec567b48] .el-card__body {\n  padding: 20px 24px !important;\n}", ""]);
// Exports
module.exports = exports;
